// extracted by mini-css-extract-plugin
export default {"container":"Tasks_container__3scaE","overview":"Tasks_overview__xBbrk","title":"Tasks_title__3_Jkz","subtitle":"Tasks_subtitle__1CBmu"};